import React from 'react';

interface ScrollableFiltersProps {
  children: any;
}

const ScrollableFilters = ({ children }: ScrollableFiltersProps) => {
  return (
    <div className="scrollable-filters">
      <div className="scrollable-filters__inner">{children}</div>
    </div>
  );
};

export default ScrollableFilters;
